import http from 'axios'

const ENDPOINT = process.env.VUE_APP_BACKEND_URL + '/login';

async function login (identifier, password) {
  if( !!localStorage.getItem('token')) {
    return {
      token: localStorage.getItem('token'),
      _: localStorage.getItem('role')
    }
  }
  // TODO passer ça en post avec des vars dans un body
  try {
    const response = await http.post(ENDPOINT + `?identifier=${identifier}&password=${password}`);
    
    // TODO des vérifs
    return response.data
  } catch (e) {
    throw e
  }
}
export default login
